/** @jsx jsx */
import { jsx } from '@emotion/core'
import { FunctionComponent } from 'react'
import { styles } from './styles'

interface HeaderProps {
  onClickLogo: () => any
  onClickCreateAccount: () => any
  onClickLogIn: () => any
  onClickWhyUs: () => any
}

export const AuthHeader: FunctionComponent<HeaderProps> = ({
  onClickLogo,
  onClickCreateAccount,
  onClickLogIn,
  onClickWhyUs,
}) => (
  <header css={styles.container}>
    <div css={styles.section}>
      <div css={styles.item}>
        <h1 css={styles.title.container} onClick={onClickLogo}>
          <span css={styles.title.name}>partscout</span>
          <span css={styles.title.ext}>.me</span>
        </h1>
      </div>
    </div>

    <div css={styles.section}>
      <div css={styles.item} onClick={onClickWhyUs} data-test-id="header-why-us">
        WHY US?
      </div>
      <div
        css={styles.item}
        onClick={onClickCreateAccount}
        data-test-id="header-create-account"
      >
        CREATE ACCOUNT
      </div>
      <div css={styles.item} onClick={onClickLogIn} data-test-id="header-sign-in">
        SIGN IN
      </div>
    </div>
  </header>
)
